import { render, staticRenderFns } from "./ImageCollections.vue?vue&type=template&id=6d96567e&"
import script from "./ImageCollections.vue?vue&type=script&lang=js&"
export * from "./ImageCollections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports